import * as Yup from "yup";

const YupSelectFieldValidation = Yup.lazy((value) => {
  if (value) {
    switch (typeof value) {
      case "string":
        return Yup.string().required("Required").nullable();
      case "object":
        return Yup.object().shape({
          _id: Yup.string().required("Required").nullable()
        });
      default:
        return Yup.mixed();
    }
  } else {
    return Yup.string().required("Required").nullable();
  }
});

export const LocalSeoSchema = Yup.object().shape({
  cities: Yup.array()
    .of(
      Yup.object().shape({
        value: Yup.string()
          .trim()
          .min(1, "City cannot be empty")
          .required("City is required")
      })
    )
    .test("unique-cities", "Cities must be unique!", (valueArray) => {
      if (!Array.isArray(valueArray)) return true;
      const values = valueArray
        .map((item) => item?.value?.trim().toLowerCase())
        .filter(Boolean);
      return new Set(values).size === values.length;
    }),
  keywords: Yup.array()
    .of(
      Yup.object().shape({
        value: YupSelectFieldValidation
      })
    )
    .test("unique-keywords", "Keywords must be unique!", (valueArray) => {
      if (!Array.isArray(valueArray)) return true;
      const values = valueArray
        .map((item) => item?.value?.name?.trim().toLowerCase())
        .filter(Boolean);
      return new Set(values).size === values.length;
    })
});

export const EditSubPageSchema = Yup.object().shape({
  seo: Yup.object().shape({
    title: Yup.string().required("Required"),
    description: Yup.string().required("Required")
  }),
  sections: Yup.array().of(
    Yup.object().shape({
      data: Yup.object().shape({
        content: Yup.object().shape({
          heading: Yup.string().nullable().required("Required"),
          paragraph: Yup.string().nullable().required("Required")
        })
      })
    })
  )
});
